/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Measure_Unit_Result_PerInputs */

const en_measure_unit_result_per = /** @type {(inputs: Measure_Unit_Result_PerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`per result`)
};

const zh_hans1_measure_unit_result_per = /** @type {(inputs: Measure_Unit_Result_PerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每条结果`)
};

const pt_br2_measure_unit_result_per = /** @type {(inputs: Measure_Unit_Result_PerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`por resultado`)
};

const es_measure_unit_result_per = /** @type {(inputs: Measure_Unit_Result_PerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`por resultado`)
};

const fr_measure_unit_result_per = /** @type {(inputs: Measure_Unit_Result_PerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`par résultat`)
};

const de_measure_unit_result_per = /** @type {(inputs: Measure_Unit_Result_PerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`pro Ergebnis`)
};

const ru_measure_unit_result_per = /** @type {(inputs: Measure_Unit_Result_PerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`за результат`)
};

const it_measure_unit_result_per = /** @type {(inputs: Measure_Unit_Result_PerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`per risultato`)
};

/**
* | output |
* | --- |
* | "per result" |
*
* @param {Measure_Unit_Result_PerInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const measure_unit_result_per = /** @type {((inputs?: Measure_Unit_Result_PerInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Measure_Unit_Result_PerInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_measure_unit_result_per(inputs)
	if (locale === "pt-BR") return pt_br2_measure_unit_result_per(inputs)
	if (locale === "es") return es_measure_unit_result_per(inputs)
	if (locale === "fr") return fr_measure_unit_result_per(inputs)
	if (locale === "de") return de_measure_unit_result_per(inputs)
	if (locale === "ru") return ru_measure_unit_result_per(inputs)
	if (locale === "it") return it_measure_unit_result_per(inputs)
	return en_measure_unit_result_per(inputs)
});